import React, { useMemo } from 'react';
import { Box, Table, TableRow, TableBody, TableHead, TableCell } from '@mui/material';
import { IProcedure } from 'interfaces/HistoricalResults/IProcedure';
import { IResultDetails } from 'interfaces/HistoricalResults/IResultDetails';
import './ProcedureResultTable.scss';

interface IProcedureResultTableProps {
  procedure: IProcedure;
  resultDetails: IResultDetails;
  resultBlock: number;
  resultIncrement: number;
}

const ProcedureResultTable = ({ procedure, resultDetails, resultBlock, resultIncrement }: IProcedureResultTableProps) => {
  const sampleNumbers = useMemo(() => {
    const sampleNumbers = [];
    const initialSampleNumber = resultBlock * resultIncrement;
    const upperSampleNumber = initialSampleNumber + resultIncrement;
    for (let sampleNumber = initialSampleNumber; sampleNumber < upperSampleNumber; sampleNumber++) {
      if (sampleNumber < procedure?.SampleList?.length && procedure?.SampleList[sampleNumber] != null) {
        sampleNumbers.push(sampleNumber);
      }
    }
    return sampleNumbers;
  }, [resultBlock, resultIncrement, procedure]);

  return (
    <Box className="procedureTable">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell width={200}>Reference</TableCell>
            <TableCell width={120}>Units</TableCell>
            <TableCell width={100}>PQL</TableCell>
            {sampleNumbers?.map((m) => (
              <TableCell width={150} key={m}>{`${resultDetails.Reference} - ${procedure.SampleList[m]?.SampleNo}`}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {procedure?.Headers?.map((m) => (
            <TableRow className="headerRow" key={m.Reference}>
              <TableCell>{m.Description}</TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              {sampleNumbers?.map((s) => (
                <TableCell key={s}>{procedure?.SampleList[s]?.Headers?.find((f) => f.No === m.No).Description}</TableCell>
              ))}
            </TableRow>
          ))}

          {procedure?.TestList?.map((m) => (
            <TableRow key={m?.TestNo}>
              <TableCell>{m.Name}</TableCell>
              <TableCell>{m.Units}</TableCell>
              <TableCell>{m.Pql}</TableCell>
              {sampleNumbers?.map((s) => (
                <TableCell key={s}>{procedure?.SampleList[s]?.Results.find((f) => f.TestNo === m?.TestNo)?.Value}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default ProcedureResultTable;
